// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__8S6BI","title":"LoginPage_title__CpwWr","loginContainer":"LoginPage_loginContainer__Ttlxk","downloadLink":"LoginPage_downloadLink__8IJIj"};